import React, { useEffect, useState,  } from 'react';
import { FormControl, VStack, WarningIcon } from 'native-base';
import { Button, Input } from '~/shared/Theme';
import { Caption } from '~/shared/Typography';

export type PinFormProps = {
    handleSubmitValues: (values: PinFormData) => void;
    isLoading: boolean;
    buttonText?: string;
    buttonType?: 'button' | 'neutral' | 'text' | 'danger';
    error?: string;
    size: number;
};

export type PinFormData = {
    pin: string;
};

export const PinForm = ({
    buttonText = 'Login',
    buttonType = 'button',
    handleSubmitValues,
    isLoading,
    error,
    size,
}: PinFormProps) => {

    const [formData, setData] =
        useState<PinFormData | null>(null);
    const [errors, setErrors] =
        useState<PinFormData | null>(null);

    useEffect(() => {

        if (error) {
            setErrors({ ...errors, pin: error });
        }
    }, [error]);

    useEffect(() => {

        if (formData?.pin.length === size) {
            onSubmit();
        }
    }, [formData?.pin.length]);

    const validate = () => {

        if (formData === null) {
            setErrors({ ...errors, pin: 'Pin is required' });
            return false;
        }
        else if (formData && formData.pin!.length < size) {
            setErrors({ ...errors, pin: 'Pin is too short' });
            return false;
        }

        setErrors(null);
        return true;
    };

    const onSubmit = () => {

        if (!validate()) {
            return;
        }

        if (!formData) {
            return;
        }

        handleSubmitValues(formData);
    };

    const onChange = (text: string) => {

        setData({ ...formData, pin: text });
    };

    return (
        <FormControl isRequired isInvalid={!!errors}>
            <FormControl.Label>
                <Caption text={'general.pin'} />
            </FormControl.Label>
            <VStack space={4}>
                <VStack>
                    <Input
                        placeholder={'1234'}
                        maxLength={size}
                        onChangeText={onChange}
                    />
                    <FormControl.ErrorMessage
                        leftIcon={<WarningIcon size={3} />}
                    >
                        { errors?.pin }
                    </FormControl.ErrorMessage>
                </VStack>
                <Button
                    variant={buttonType}
                    text={buttonText || 'auth.ten_dlc.login.submit_pin'}
                    loading={isLoading}
                    disabled={formData?.pin.length !== size}
                    onPress={onSubmit}
                />
            </VStack>
        </FormControl>
    );
};

export default PinForm;
